import React from 'react';
import { useTranslation } from 'react-i18next';

interface IErrorLabel {
  message: string;
  placeholders?: Record<string, string>;
}

export const ErrorLabel = ({ message, placeholders }: IErrorLabel) => {
  const { i18n } = useTranslation();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <span className="form__error">{i18n.t(message as any, placeholders)}</span>;
};
